export default __webpack_public_path__ + "static/media/Inter-SemiBoldItalic.3c66f84b.woff2";